import { render, staticRenderFns } from "./legacy-divider-line.vue?vue&type=template&id=5857e17e&"
import script from "./legacy-divider-line.vue?vue&type=script&lang=js&"
export * from "./legacy-divider-line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports